import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';
import HTML from '../../Helpers/HTML';
import UserLabel from './UserLabel';
import UserBox from '../../Helpers/User/UserBox';
import Time from '../../Helpers/Time';
import UrlPusher from '../../Helpers/UrlPusher';
import Image from './MessageTypes/Image';
import Text from './MessageTypes/Text';
import moment from 'moment';
import onClick from '../../../utils/onClick';
import { inject, observer } from "mobx-react";
import { makeObservable, observable, reaction,toJS } from "mobx";

//actions
import fetchChatNewMessages from '../../../actions/chat/fetchChatNewMessages';
import setChatState from '../../../actions/chat/setChatState';
import Loading from "../../Loading";

class ChatMessages extends Component {
  messages=[];
  messages_inited=false;
  id_of_last_message=0;
  id_of_first_message=false;
  last_message=0;
  selected_messages=[];
  selected_messages_restore=[];
  scroll_to=false;
  new_messages_while_hidden=false;

  constructor(props) {
    super(props);
    makeObservable(this,{
      messages:observable,
      id_of_last_message:observable,
      id_of_first_message:observable,
      last_message:observable,
      selected_messages:observable,
      selected_messages_restore:observable,
      scroll_to:observable,
      new_messages_while_hidden:observable,
      messages_inited:observable,
    })
    this.state = {
      messages:[],
      id_of_last_message:0,
      id_of_first_message:false,
      last_message:0,
      selected_messages:[],
      selected_messages_restore:[],
      scroll_to:false,
      new_messages_while_hidden:false,
    };
    this._onResize=(e)=>{
      if(!this._resizeStarted) {
        this._resizeStarted=true;
        this.onStartResize();
        this.onContinueResize();
      } else {
        this.onContinueResize();
      }

      /*console.log('on resize!',this._lastScrollTop);
      if(this._lastScrollTop == 'bottom') {
        if(this._ref.scrollTop) {
          this._ref.scrollTop = this._ref.scrollHeight - this._ref.clientHeight
        }
      }*/
      if(this._resizeTa) {
        clearTimeout(this._resizeTa);
      }
      this._resizeTa=setTimeout(()=>{
        this._resizeStarted=false;
        this.onStopResize();
      },300);
    };
    this._onScroll=()=>{
      if(this._blockScrollHandler) {
        console.log('scroll blocked ',this._lastScrollTop);
        return false;
      } else {

      }
      if(this._ref.scrollTop === 0) {
        this.loadMessages(true);
      }
      //console.log('check scroll',this._ref.scrollTop, this._ref.scrollHeight - this._ref.clientHeight);
      if(this._ref.scrollTop >= this._ref.scrollHeight - this._ref.clientHeight) {
        if(parseInt(this.props.info.chat.id_of_last_message) > this.id_of_last_message) {
          //this._lastScrollTop='tolast';
          this._lastScrollLast=this._lastScrollTop;
          this.loadMessages();
        } else {
          this._lastScrollTop='bottom';
        }
      } else {
        this._lastScrollTop='na';
      }
      console.log('scroll fired ',this._lastScrollTop);
      //console.log('scroll!',this._ref.scrollTop,this._ref.scrollHeight);
    };
    this.reactions=[];
    this.reactions.push(reaction(()=>{
      return this.scroll_to;
    },(scrollTo)=>{
      console.log("scroll try",toJS(this.scroll_to));
      if(scrollTo) {
        const messageRef=document.querySelector(".chatMessage[data-message-id='"+scrollTo.id+"']");
        const wrapRect = this._ref.getBoundingClientRect();
        const messageRect = messageRef.getBoundingClientRect();
        this._ref.scrollTop = messageRect.top - wrapRect.top;
        this.scroll_to=false;
      }
    }));
    this.reactions.push(reaction(()=>{
      return this.props.chatStore.ws_cmd;
    },(cmd)=>{
      if(cmd) {
        if (cmd.chat_id == this.props.chat_id) {
          if (cmd.message === "new_messages") {
            if (this.props.appStateStore.app_visible) {
              this.last_message=parseInt(cmd.message_id)
              this.loadMessages();
            } else {
              this.new_messages_while_hidden=true;
            }
          }
        }
      }
    }));
    this.reactions.push(reaction(()=>{
      return this.props.appStateStore.app_visible;
    },(appVis)=>{
      if(appVis && this.new_messages_while_hidden) {
        let lastMessageId = 0;
        if (this.messages && this.messages.length) {
          lastMessageId = parseInt(this.messages[this.messages.length - 1].id);
        }
        this.last_message=lastMessageId;
        this.new_messages_while_hidden=false;
        this.loadMessages();
      }

    }));

  }
  onContinueResize() {
    if(this._savelastScrollTop == 'bottom') {
      if (this._ref.scrollTop) {
        this._ref.scrollTop = this._ref.scrollHeight - this._ref.clientHeight +20
      }
    }
    console.log('continue resize!');
  }
  onStartResize() {
    this._blockScrollHandler=true;
    this._savelastScrollTop=this._lastScrollTop;
    console.log('start resize!',this._lastScrollTop);
  }
  onStopResize() {
    this._blockScrollHandler=false;
    if(this._savelastScrollTop == 'bottom') {
      this._ref.scrollTop = this._ref.scrollHeight - this._ref.clientHeight + 20
    }
  }
  loadMessages(getTop=false, messageId=false) {
    let ob={};
    if(messageId) {
      ob.message_id=messageId;
    } else {
      if (getTop) {
        ob.id_of_first_message = this.id_of_first_message;
      } else {
        ob.id_of_last_message = this.id_of_last_message;
      }
    }
    const str=qs.stringify(ob);
    axios.get(`/api/privatechat/${this.props.chat_id}/messages?${str}`).then((data)=>{
      //console.log('load messages',this.props.chatStore.new_messages.data,this.props.chat_id+'');
      if(this.props.chatStore.new_messages.data.indexOf(this.props.chat_id+'')>-1) {
        this.props.chatStore.fetchNewMessages();
      }
      this.parseMessages(data.data.answer,getTop, messageId);
      this.messages_inited=true;
    });
  }
  parseMessages(data,getTop=false,messageId=false) {
    const tailAndHead={
      first:this.messages.length?this.messages[0].id:false,
      last:this.messages.length?this.messages[this.messages.length-1].id:false,
    };

    for(let i in data.items) {
      const item=data.items[i];
      this.messages.push(item);
    }
    this.messages.sort((left,right)=>{
      left=parseInt(left.id);
      right=parseInt(right.id);
      if(left>right) {
        return 1;
      }
      if(left<right) {
        return -1;
      }
      if(left===right) {
        return 0;
      }
    });

    let scroll_to=null;
    if(messageId) {
      scroll_to={id:messageId};
    } else {
      if(getTop) {
        scroll_to={id:tailAndHead.first};
      }
    }

    console.log('scroll_to',scroll_to);

    if(parseInt(data.id_of_last_message)>this.id_of_last_message) {
      this.id_of_last_message = parseInt(data.id_of_last_message);
    }
    if(this.messages.length) {
      if (this.id_of_first_message === false || parseInt(this.messages[0].id) < this.id_of_first_message) {
        // console.log('set first!', parseInt(cloned[0].id));
        this.id_of_first_message = parseInt(this.messages[0].id);
      }
    }

    this.scroll_to=scroll_to;

    // this.setState(newState);
    
  }

  componentWillMount() {
    if(this.props.message_id) {
      this._lastScrollTop='na';
      this.loadMessages(false, this.props.message_id);
    } else {
      this._lastScrollTop = 'bottom';
      this.loadMessages();
      /*
      if (this.props.chat_state.chat_options && this.props.chat_state.chat_options[this.props.chat_id]) {
        const opts = this.props.chat_state.chat_options[this.props.chat_id];
        if (opts.message_id) {
          this._lastScrollTop = 'na';
          this.loadMessages(false, opts.message_id);
          this.props.chatStore.main_window={};
          this.props.setChatState({win: null});

        } else {
          this.loadMessages();
        }
      } else {
        this._lastScrollTop = 'bottom';
        this.loadMessages();
      }
      */
    }
  }
  renderNewmessagesHere() {
    return (
      <div className="vpadd5 hpadd10 tac dotted1-bottom bo-w5" key={`new_messages`}>
        new messages
      </div>
    )
  }
  checkReadedHere(iReturn,item) {
    let users=[];
    let key='';
    for(let i in this.props.info.items) {
      const cur=this.props.info.items[i];
      if(cur.user_table_nick !== this.props.meStore.me.data.nick) {
        if(cur.id_of_last_message == item.id) {
          key+='-'+cur.user_table_nick;
          users.push(
            <UserLabel info={cur} key={cur.user_id} />
          );
        }
      }
    }
    if(users.length>0) {
      iReturn.push(
        <div className="vpadd5 hpadd10 " key={key}>
          {users}
        </div>
      );
    }
  }
  isOneOnOne() {
    if(this.props.info.chat.name == 'one_on_one') {
      return true;
    }
    return false;
  }
  isSelected(messageId) {
    if(this.selected_messages.indexOf(messageId)>-1) {
      return true;
    }
    if(this.isSelectedForRestore(messageId)) {
      return true;
    }
    return false;
  }
  isSelectedForRestore(messageId) {
    if (this.selected_messages_restore.indexOf(messageId) > -1) {
      return true;
    }
    return false;
  }
  selectMessage(messageItem) {
    const messageId=messageItem.id;
    if(messageItem.mark_delete) {
      this.selectMessageForRestore(messageId);
    } else {
      const index=this.selected_messages.indexOf(messageId);
      if (index > -1) {
        this.selected_messages.splice(index,1);
      } else {
        this.selected_messages.push(messageId);
      }
    }
  }
  selectMessageForRestore(messageId) {
    let selected = this.selected_messages_restore;
    const index = selected.indexOf(messageId)
    if (index > -1) {
      selected.splice(index, 1);
    } else {
      selected.push(messageId);
    }
    // this.setState({selected_messages_restore: selected});
  }
  renderMessage(item) {
    if(item.type === 'text') {
      return (
        <Text item={item} reScroll={()=>{ this.reScroll(); }} />
      )
    }
    if(item.type === 'image') {
      return (
        <Image reScroll={()=>{ this.reScroll(); }} item={item} />
      )
    }
  }
  reScroll() {
    if (typeof this._lastScrollTop === 'undefined' || this._lastScrollTop == 'bottom') {
      this._blockScrollHandler=true;
      this._ref.scrollTop = this._ref.scrollHeight - this._ref.clientHeight +10;
      clearTimeout(this._blockScrollTa);
      this._blockScrollTa=setTimeout(()=>{
        this._blockScrollHandler=false;
      },1000);

    } else {

    }
  }
  renderMessages() {
    if(!this.messages_inited) {
      return (
        <Loading />
      )
    }
    let iReturn=[];
    let newLineWasPushed=false;
    if(this.messages && this.messages.length) {
      let lastDate='';
      for (let i in this.messages) {

        const item = this.messages[i];
        const isSelected=this.isSelected(item.id)
        if (!newLineWasPushed && parseInt(item.id) > this.getIdOfLastRead()) {
          newLineWasPushed = true;
          iReturn.push(this.renderNewmessagesHere());
        }

        //let curDate=moment(item.time);
        if(lastDate && lastDate !== moment(item.time).format('DD-MM-YYYY')) {
          iReturn.push(
            <div key={item.time} className={`${this.props.standalone?'fs13 s-vpadd3 m-vpadd10 s-hpadd10':'fs13 vpadd5 hpadd5'} b4 wordBreak tac `}>
              <span className="dib w1 op50 rad200 hpadd10 vpadd3 bg-b1-op70">
                <Time value={item.time} forcedate={true}/>
              </span>
            </div>
          )
        }


        if (this.props.meStore.me.data.id === item.user_id) {
          iReturn.push(
            <div data-message-id={item.id} className={`chatMessage ${this.props.standalone?'s-vpadd3 s-hpadd10 m-vpadd10 m-hpadd25':'vpadd5 hpadd10'} wordBreak ${item.mark_delete?'op20':''}`} key={item.id} {...onClick((e)=>{ {/*e.preventDefault();*/} this.selectMessage(item); })}>
              <div className="up12 s-nowrap splice">
                <div className="cell s-shrink">
                  <div style={{width: 30}}></div>
                </div>
                <div className="cell s-auto pleft5">
                  <div className={`${this.props.standalone?'fs15 s-padd5 m-padd10':'fs13 padd5'} rad3 pr ${isSelected?'bg-sc1 w1 selectedMessage':'bg-pc3 b2'}`}>
                    <div className="ownTriangle pa"></div>

                    <div className="up12 splice">
                      <div className={`cell s-auto ${isSelected?'w1':''}`}>
                        {this.renderMessage(item)}
                      </div>
                      <div className={`cell s-shrink fs11  s-end ${isSelected?'w2-op50':'pc1-op50'}`}>
                        <Time value={item.time} forcetime={true} />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        } else {
          if (item.type == 'system') {
            iReturn.push(
              <div data-message-id={item.id} className={`chatMessage ${this.props.standalone?'fs15 s-vpadd3 m-vpadd10 s-hpadd10':'fs13 vpadd5 hpadd5'} bold b4 wordBreak `} key={item.id}>
                {item.message}
              </div>
            );
          } else {
            iReturn.push(
              <div data-message-id={item.id} className={`chatMessage ${this.props.standalone?'s-vpadd3 s-hpadd10 m-vpadd10 m-hpadd25':'vpadd5 hpadd10'} wordBreak ${item.mark_delete?'op20':''}`} {...onClick((e)=>{ {/*e.preventDefault();*/} this.selectMessage(item); })} key={item.id}>
                <div className="up12 s-nowrap splice">
                  {!this.isOneOnOne()?(
                    <div className="cell s-shrink">
                      <UserBox
                        avatar={item.user_table_avatar}
                        nick={item.user_table_nick}
                        size={30}
                      />
                    </div>
                  ):null}
                  <div className="cell s-auto pleft5">
                    <div className={`${this.props.standalone?'fs15 s-padd5 m-padd10':'fs13 padd5'}  rad3 pr ${isSelected?'bg-sc1 b2 selectedMessage':'bg-w2'}`}>
                      <div className="otherTriangle pa"></div>
                      <div className="up12 splice">
                        <div className={`cell s-auto ${isSelected?'w1':''}`}>
                          {!this.isOneOnOne()?(<div className={isSelected?'w1-op50':'pc1'}>{item.user_table_nick}</div>):null}
                          {this.renderMessage(item)}
                        </div>
                        <div className={`cell s-shrink fs11 s-end ${isSelected?'w2-op50':'w4'}`}>
                          <Time value={item.time} forcetime={true} />
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.isOneOnOne()?(
                    <div className="cell s-shrink">
                      <div style={{width: 30}}></div>
                    </div>
                  ):null}
                </div>
              </div>
            )
          }
        }
        this.checkReadedHere(iReturn, item);
        lastDate=moment(item.time).format('DD-MM-YYYY');
      }
    }
    return iReturn;
  }
  componentWillUnmount() {
    for(let i in this.reactions) {
      this.reactions[i]();
    }
    if(this.props.standalone) {
      window.removeEventListener('resize', this._onResize);
    }
  }

  componentDidMount() {
    this._ref.addEventListener('scroll',this._onScroll);
    if(this.props.standalone) {
      window.addEventListener('resize', this._onResize);
    }

    this.last_message=parseInt(this.props.info.chat.chat_user_id_of_last_message)

    this.reScroll();
  }
  getIdOfLastRead() {
    return this.last_message;
    /*if(this.state.id_of_last_message) {
      return parseInt(this.state.id_of_last_message);
    } else {

    }*/
  }
  
  
  restoreMessages() {
    axios.post(`/api/privatechat/${this.props.chat_id}/messages_restore`,{ ids:this.selected_messages_restore }).then((data)=>{
      let mess=this.messages;
      for(let i in mess) {
        if(this.selected_messages_restore.indexOf(mess[i].id)>-1) {
          mess[i].mark_delete=false;
        }
      }
      this.selected_messages_restore=[];
      // this.setState({ messages:mess, selected_messages_restore:[] });
      //this.state.selected_messages
    });
  }
  deleteMessages() {
    axios.delete(`/api/privatechat/${this.props.chat_id}/messages`,{data:{ ids:this.selected_messages }}).then((data)=>{
      let mess=this.messages;
      for(let i in mess) {
        if(this.selected_messages.indexOf(mess[i].id)>-1) {
          mess[i].mark_delete='1';
        }
      }
      this.selected_messages=[];
      // this.setState({ messages:mess, selected_messages:[] });
      //this.state.selected_messages
    });
  }
  renderSelected() {
    if(this.selected_messages.length>0 || this.selected_messages_restore.length>0) {
      return (
        <div className="padd10 bg-w1 solid1-bottom bo-w2">
          <div className="up12 splice">
            <div className="cell s-12 fs12 pbottom10 sc1">
              Выделено сообщений: {this.selected_messages.length+this.selected_messages_restore.length}
            </div>
            <div className="cell s-auto">
              {this.selected_messages.length?(
                <span className="btn6 small mright10" onClick={()=>{ this.deleteMessages(); }}><span>
                  <i className="mdi mdi-delete op50"></i>
                  Удалить
                </span></span>
              ):null}
              {this.selected_messages_restore.length?(
                <span className="btn2 small" onClick={()=>{ this.restoreMessages(); }}><span>
                  Восстановить
                </span></span>
              ):null}
            </div>
            <div className="cell s-shrink">
              <span className="btn2 small" onClick={()=>{ this.selected_messages=[]; this.selected_messages_restore=[]; }}><span>{this.props.translateStore.t.evaPrivateChat.cancel}</span></span>
            </div>
          </div>

        </div>
      )
    } else {
      return null;
    }
  }
  render() {
    return (
      <div className="h100" >
        <div className="up12-v  splice h100">
          <div className="v-cell s-v-shrink">
            {this.renderSelected()}
          </div>
          <div className="v-cell s-v-auto">
            <div style={{height:'100%'}} className="ofa bg-w1 " ref={(ref)=>{ this._ref=ref; }}>
              {this.renderMessages()}
            </div>
          </div>
        </div>


      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    chat_ws:state.chat_ws,
    chat_new_messages:state.chat_new_messages,
    chat_state:state.chat_state,
    app_visible:state.app_visible,
    t: state.translate,
  }
}

// export default connect(mapStateToProps,{ fetchChatNewMessages, setChatState }, null, { withRef:true })(ChatMessages);
export default inject("meStore","chatStore","appStateStore","translateStore")(observer(ChatMessages));